import React, {Component, ErrorInfo, ReactNode} from 'react';
import ErrorFallbackMessage from './ErrorFallbackMessage';
import {reportClientError} from 'app/utils/reportClientError';

interface PropsInterface {
    children: ReactNode
    path: string
}

interface StateInterface {
    failed: boolean
    path: string
}

export default class PageErrorBoundary extends Component<PropsInterface, StateInterface> {
    static getDerivedStateFromError(): Partial<StateInterface> {
        return {failed: true};
    }

    static getDerivedStateFromProps(props: PropsInterface, state: StateInterface): Partial<StateInterface> | null {
        return props.path === state.path ? null : {failed: false, path: props.path};
    }

    state: StateInterface = {failed: false, path: this.props.path};

    componentDidCatch(error: Error, info: ErrorInfo): void {
        reportClientError(error, this.props.path, info.componentStack);
    }

    render(): ReactNode {
        return this.state.failed ? <ErrorFallbackMessage/> : this.props.children;
    }
}
